import { useState } from 'react';

import { SelectionOptions } from 'coreOld/enums';
import { useAppDispatch } from 'coreOld/hooks';
import { setSelectionMode } from 'coreOld/slices';

import SelectAllView from './SelectAllView';

interface IProps {
  getToggleAllRowsSelectedProps;
  toggleAllRowsSelected;
  isAllRowsSelected: boolean;
  selectMenuOptions?: SelectionOptions[];
  disabled?: boolean;
}

const SelectAll = ({
  getToggleAllRowsSelectedProps,
  selectMenuOptions,
  toggleAllRowsSelected,
  isAllRowsSelected,
  disabled = false,
}: IProps) => {
  const dispatch = useAppDispatch();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onItemClick = (event) => {
    dispatch(setSelectionMode(event?.target?.textContent || SelectionOptions.NONE));
    toggleAllRowsSelected(true);
    setIsMenuOpen(false);
  };

  const onChange = (event) => {
    if (selectMenuOptions && !isAllRowsSelected) {
      setIsMenuOpen((prev) => !prev);

      return;
    }

    dispatch(setSelectionMode(SelectionOptions.NONE));
    getToggleAllRowsSelectedProps()?.onChange(event);
  };

  return (
    <SelectAllView
      {...{
        getToggleAllRowsSelectedProps,
        toggleAllRowsSelected,
        selectMenuOptions,
        isAllRowsSelected,
        isMenuOpen,
        setIsMenuOpen,
        onItemClick,
        onChange,
        disabled,
      }}
    />
  );
};

export default SelectAll;
